<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'
import { AppRoute } from '@shared/config'

import TableCustomers from './list/TableCustomers.vue'
import { useCustomersApi } from '../api/list/list.hook'

defineOptions({
  name: 'CustomersListPage',
})

const route = useRoute()

onMounted(() => {
  void useCustomersApi()
})

// Filters, pagination and the sidebar link all navigate by query; refetching here keeps the table
// in sync with the URL, including a sidebar click while already on this page.
watch(() => route.query, () => {
  if (route.path === AppRoute.Customers) {
    void useCustomersApi()
  }
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(() => {
  void useCustomersApi()
})
</script>

<template>
  <TableCustomers />
</template>
